// src/components/Header.js
import React from "react";
import { Link } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import LogoutButton from "../components/LogoutButton";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const changeLanguage = (e) => {
    const selectedLang = e.target.value;
    i18n.changeLanguage(selectedLang);
  };

  return (
    <header className="p-3 bg-white text-dark">
      <div className="container">
        <div className="d-flex flex-wrap align-items-center justify-content-between">
          <Link to="/" className="d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none">
            <h3 className="m-0 me-3">GO DRIVE Partner</h3>
          </Link>

          <ul className="nav me-auto align-items-right">
            {user?.role === "admin" ? (
              <Dropdown className="me-2">
                <Dropdown.Toggle variant="white" id="dropdown-basic">
                  {t("adminHeader")}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="/admin/users">{t("users")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/addnewuser"> - {t("addUser")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/upload-incomings">{t("uploadUberBolt")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/edit-source-data/bolt"> - {t("edit")} BOLT</Dropdown.Item>
                  <Dropdown.Item href="/admin/edit-source-data/uber"> - {t("edit")} UBER</Dropdown.Item>

                  <Dropdown.Item href="/add-freenow-info">{t("addFreenow")}</Dropdown.Item>
                  <Dropdown.Item href="/edit-freenow-info">- {t("editFreenow")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/driver-debts">{t("driverDebts")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/driver-extra-funds">{t("extraCosts")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/driver-raport">{t("raports")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/check-reports">- {t("checkreport")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/cash-stats">{t("cashRaports")}</Dropdown.Item>
                  <Dropdown.Item href="/settings">{t("usersettings")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/settings">{t("sitesettings")}</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button variant="light" href="/">{t("raports")}</Button>

              
            )}
          </ul>

          {/* Мова + вихід */}
          <div className="d-flex align-items-center ms-auto">
          {user && (
            <div className="ms-3">
              <span className="me-2">{t("hello")}, {user.firstName}!</span>
            </div>
          )}
            <select
              onChange={changeLanguage}
              value={i18n.language}
              className="form-select w-auto me-2"
            >
              <option value="ua">UA</option>
              <option value="en">EN</option>
              <option value="pl">PL</option>
              <option value="ru">🇷🇺</option>
            </select>

            <div className="me-2">
              <LogoutButton />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
